import LoadingScreen from 'components/LoadingScreen';
import callApi from 'lib/callApi';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Table, Row, Col } from 'reactstrap';

const headerConfig = [
  { title: '#' },
  { title: 'Open Status' },
  { title: 'Open Date' },
  { title: 'Close Status' },
  { title: 'Close Date' },
  { title: 'Age (Days)' },
];

const TableHeader = headerConfig.map(({ title }) => {
  return (
    <th
      style={title === 'Age (Days)' ? { textAlign: 'right' } : {}}
      key={title}
    >
      {title}
    </th>
  );
});

type Props = {
  findingId: number;
};

async function getStatusData(findingId) {
  try {
    if (findingId) {
      const params = {
        finding_id: findingId,
      };

      const responseData = await callApi(
        'findings/status_history',
        'GET',
        params,
      );
      return responseData?.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return [];
}

const StatusDetails = ({ findingId }: Props) => {
  const [loading, setLoading] = useState(false);
  const [statusData, setStatusData] = useState<any[]>([]);

  useEffect(() => {
    if (findingId) {
      setLoading(true);
      getStatusData(findingId).then((data) => {
        setStatusData(data);
        setLoading(false);
      });
    }
  }, [findingId]);

  return (
    <Fragment>
      <Row>
        <Col>
          <Table className="tablesorter table-striped" responsive>
            <thead className="text-primary">
              <tr>{TableHeader}</tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={6}>
                    <LoadingScreen />
                  </td>
                </tr>
              )}
              {statusData?.map((dataItem, index) => {
                return (
                  <tr key={index} className={'dynamic-select-tr'}>
                    <td className="col-md-1">{index + 1}</td>
                    <td>
                      {dataItem['open_status'] ? dataItem['open_status'] : '-'}
                      {dataItem['open_by'] && dataItem['open_by'].length > 0 ? (
                        <span
                          style={{ display: 'block', cursor: 'pointer' }}
                          title={dataItem['open_by']}
                        >
                          {' '}
                          <i>(by {dataItem['open_by']})</i>
                        </span>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {dataItem['open_date'] && dataItem['open_date'].length > 0
                        ? moment(dataItem['open_date']).format('lll')
                        : '-'}
                    </td>
                    <td>
                      {dataItem['close_status']
                        ? dataItem['close_status']
                        : '-'}
                      {dataItem['close_by'] &&
                      dataItem['close_by'].length > 0 ? (
                        <span
                          style={{ display: 'block', cursor: 'pointer' }}
                          title={dataItem['close_by']}
                        >
                          {' '}
                          <i>(by {dataItem['close_by']})</i>
                        </span>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>
                      {dataItem['close_date'] &&
                      dataItem['close_date'].length > 0
                        ? moment(dataItem['close_date']).format('lll')
                        : '-'}
                    </td>
                    <td className="col-md-1" style={{ textAlign: 'right' }}>
                      {dataItem['age']}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Fragment>
  );
};

export default StatusDetails;
